import React from 'react'

class ButtonRefreshWithoutIconComponent extends React.Component {
  render () {
    return (
      <div style={styles.buttonContent}>
        <button
          disabled={this.props.disabled}
          onClick={this.props.onClick}
          style={!this.props.checked ? styles.enabledButton : styles.disabledButton}>
          <span style={!this.props.checked ? styles.enabledLabel : styles.disabledLabel}>{this.props.label}</span>
        </button>
      </div>
    )
  }
}

const styles = {
  buttonContent: {
    marginTop: '10px',
    float: 'right',
    height: '26px'
  },
  enabledButton: {
    border: 'none',
    float: 'right',
    cursor: 'pointer',
    width: 'auto',
    height: '26px',
    borderRadius: '10px',
    backgroundColor: '#7ED321',
    outline: 'none'
  },
  disabledButton: {
    float: 'right',
    width: 'auto',
    height: '26px',
    border: '1px solid #748591',
    borderRadius: '10px',
    backgroundColor: '#374148'
  },
  enabledLabel: {
    marginLeft: '14px',
    marginRight: '12px',
    color: '#272D31',
    fontSize: '12px',
    fontWeight: 700
  },
  disabledLabel: {
    marginLeft: '14px',
    marginRight: '12px',
    color: '#748591',
    fontSize: '12px',
    fontWeight: 700
  },
}

export default ButtonRefreshWithoutIconComponent
